module.exports = __webpack_public_path__ + "static/media/W5390484_26.a1bb6c3f.jpg";